import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import { useGetUserDataQuery } from "../../services/login";
import HelmetComponent from "../../Components/HelmetComponent";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import { getMetaByCountry } from "../../metaConfig";
import formatPrice from "../../Components/formatPrice";
function ShippingPolicy() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const myElementRef = React.useRef(null);
  const myElementRefs = React.useRef(null);
  const myContact = React.useRef(null);

  const myPayment = React.useRef(null);
  const myBilling = React.useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "returns") {
        myElementRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "shipping") {
        myElementRefs.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "contact") {
        myContact.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "billing") {
        myBilling.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "payment") {
        myPayment.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [window, window.location.hash]);

  const [isMetaTitle, setMetaTitle] = useState("");
  useEffect(() => {
    const { title } = getMetaByCountry(countryCode);
    setMetaTitle(title);
  }, [countryCode]);

  return (
    <>
      <HelmetComponent title={"Shipping Policy"} metaTitle={isMetaTitle} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>
                  {t("Shipping Policy")}
                </h1>

                <p>
                  This Shipping Policy applies to orders delivered within the {userData?.contant?.country} through{" "}
                  {window.location.hostname}.
                </p>
                <p>By placing an order on our website, you agree to the shipping terms stated below.</p>

                <h4>A. Shipping Costs and Delivery Fee</h4>
                <p>{Host?.domainName2} handles the shipping arrangements for customer orders.</p>
                <p>
                  A flat delivery fee of{" "}
                  {formatPrice(userData?.contant?.standard_delivery, userData?.contant?.currency, 0)} per order is
                  charged in the cart and shown before checkout.
                </p>
                <p>
                  Customers will not be charged any additional delivery, handling, or shipping fee after placing the
                  order unless the customer expressly approves a requested change, such as a special delivery
                  arrangement.
                </p>

                <h4>B. Order Processing Time</h4>
                <p>Orders are usually processed within 1 to 3 working days after order confirmation.</p>
                <p>Working days are Monday to Friday, excluding UAE public holidays.</p>
                <p>
                  Orders placed outside working hours, during weekends, or on UAE public holidays may be processed on
                  the next working day.
                </p>

                <h4>C. Transit and Delivery Time</h4>
                <p>
                  After dispatch, shipments are generally in transit for 7 to 12 working days, depending on the delivery
                  location, courier, product type, and operational conditions.
                </p>
                <p>The estimated total delivery time is usually 8 to 15 working days from order confirmation.</p>
                <p>
                  Delivery timelines are estimates and may be affected by courier delays, high order volume, public
                  holidays, weather conditions, incorrect address details, customer availability, or events outside our
                  reasonable control.
                </p>

                <h4>D. Transport Courier</h4>
                <p>We deliver products through recognized courier and logistics partners, which may include:</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• DHL;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• FedEx;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• UPS;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• FlipXp;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • other approved delivery partners where required.
                </p>
                <p>
                  The courier used for each order may vary depending on the delivery location, product type, and
                  availability of service.
                </p>

                <h4>E. Change of Delivery Address</h4>
                <p>
                  Customers are responsible for providing a complete and accurate delivery address and contact number at
                  the time of placing the order.
                </p>
                <p>
                  If you need to change the delivery address, please contact us within 24 hours of placing the order at:
                </p>
                <p>Email: {Host?.email}</p>
                <p>
                  We may be able to update the delivery address if the order has not yet been processed or dispatched.
                </p>
                <p>
                  Once an order is in transit, we may not be able to change the delivery address. If a delivery address
                  change is possible through the courier, additional delivery charges or delays may apply.
                </p>

                <h4>F. Order Cancellation Before Shipment</h4>
                <p>Customers may request cancellation before the order has been shipped.</p>
                <p>
                  If the order has not yet been shipped or processed for dispatch, we may cancel the order and issue a
                  refund in accordance with our Returns, Refunds, Cancellation & Warranty Policy.
                </p>
                <p>
                  Once an order has been shipped, cancellation may no longer be possible. In such cases, the order will
                  continue for delivery.
                </p>
                <p>
                  We do not accept returns, refunds, or exchanges after delivery for change of mind, buyer's remorse,
                  incorrect selection by the customer, or products ordered by mistake, unless otherwise required by
                  applicable law or expressly stated on the product page.
                </p>
                <p>
                  This does not affect the customer's right to request support if the item received is damaged,
                  defective, incorrect, or not as described.
                </p>

                <h4>G. Failed Delivery Attempts</h4>
                <p>
                  Customers must ensure that they are available to receive the order or that an authorized person is
                  available at the delivery address.
                </p>
                <p>
                  If delivery fails because the customer is unavailable, provides an incorrect address, refuses
                  delivery, or cannot be contacted by the courier, the order may be returned to us.
                </p>
                <p>
                  In such cases, re-delivery fees may apply. If the order is cancelled after failed delivery due to
                  customer-related reasons, any applicable delivery, courier, cash-on-delivery, or handling charges may
                  be deducted from the refund where permitted by applicable law.
                </p>

                <h4>H. Parcels Damaged in Transit</h4>
                <p>
                  If the package appears damaged at the time of delivery, customers should reject the package from the
                  courier where possible and contact our customer support team immediately.
                </p>
                <p>
                  If the package was delivered without the customer being present, or if damage is noticed after
                  delivery, the customer should contact us within 3 days of delivery.
                </p>
                <p>Please provide:</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• order number;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • clear photos or video of the damaged product;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• photos of the outer packaging;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • photos of the shipping label, if available;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• a short description of the issue.</p>
                <p>
                  Damaged, defective, incorrect, or missing item claims will be reviewed in accordance with our Returns,
                  Refunds, Cancellation & Warranty Policy.
                </p>

                <h4>I. Product Availability and Delivery Updates</h4>
                <p>
                  We make reasonable efforts to keep product availability and delivery estimates accurate and updated.
                </p>
                <p>
                  In rare cases, a product may become unavailable or delayed after an order is placed due to
                  supplier-side stock changes, courier limitations, fulfillment delays, system updates, or other
                  operational reasons.
                </p>
                <p>
                  If this happens, we will contact the customer promptly and offer one or more of the following options:
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • wait for the product to become available;
                </p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• choose an alternative product;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>
                  • cancel the affected item and receive a full refund for that item.
                </p>
                <p>
                  We do not charge customers any additional amount after order confirmation without the customer's
                  express approval.
                </p>
                <h4>J. Central Warehouse Location</h4>
                <p>
                  Items are shipped and fulfilled from our central warehouse in the UAE and delivered to customers
                  across the {userData?.contant?.country}. This allows us to manage inventory efficiently, maintain
                  quality control, and process orders in a consistent and reliable manner.
                </p>

                <h4>K. Cut off Time</h4>
                <p>
                  Orders placed before 4:00PM GST on business days begin processing the same day. Orders placed after
                  this time begin processing for the next business day.
                </p>

                <h4>L. Contact Information</h4>
                <p>For shipping, delivery, or tracking support, please contact:</p>
                <div style={{ fontSize: "14px" }}>
                  <strong>Trade Name: {Host?.domainName2}</strong>
                  <br />
                  <strong>Trade License: {Host?.companyName}</strong>
                  <br />
                  <strong>License Number: {Host?.licenseNumber}</strong>
                </div>
                <p style={{ lineHeight: 2 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: Host?.address,
                    }}
                  ></div>
                  <MailOutlineIcon style={{ fontSize: "18px" }} /> {Host?.email} <br />
                  <PhoneIcon style={{ fontSize: "18px" }} /> {Host?.phone}
                </p>

                <p>Customer Support: {Host?.customerSupport}</p>
                <p>Website: {window.location.hostname}</p>

                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShippingPolicy;
